import { JsBridge, encodeData, SendPreferenceCRMData } from './js-bridge';

export class JsBridgeIOS extends JsBridge {
    appCloseNativePIP(): void {
        webkit?.messageHandlers.closeNativePIP.postMessage({});
    }
    appOpenRacingLiveStream(): void {
        webkit?.messageHandlers.IosDiscoverJsBridge_AppOpenRacingLiveStream.postMessage({});
    }
    appGetLocalStorageDataRequest(): void {
        // console.log('call appGetLocalStorageDataRequest------IOS');
        webkit?.messageHandlers.IosDiscoverJsBridge_GetLocalStorageDataRequest.postMessage({});
    }
    appGetLocalStorageDataRequestAsync(): void {
        console.log('call appGetLocalStorageDataRequestAsync------IOS');
    }
    appShareUrl(url: string): void {
        webkit?.messageHandlers.IosDiscoverJsBridge_ShareUrl.postMessage({ url });
    }
    // appDirectTo(page: 'CouponList' | 'P-CardPage'): void {
    //     webkit?.messageHandlers.IosDiscoverJsBridge_DirectTo.postMessage({ directTo: page });
    // }
    appOpenExternalBrowser(url: string): void {
        webkit?.messageHandlers.IosDiscoverJsBridge_OpenExternalBrowser.postMessage({ url });
    }
    appSetUiVisibility(ui: 'btnBack' | 'btnCalendar' | 'btnSkip', visable: boolean): void {
        webkit?.messageHandlers.IosDiscoverJsBridge_AppSetUiVisibility.postMessage({
            type: ui,
            isVisible: visable,
        });
    }
    appSaveDiscoverPreference(data: SendPreferenceCRMData): void {
        const jsonStringBase64 = encodeData(data);
        webkit?.messageHandlers.IosDiscoverJsBridge_appSaveDiscoverPreference.postMessage({
            data: jsonStringBase64,
        });
    }
    appOpenNativePlayer(url: string): void {
        console.log('appOpenNativePlayer', url);
    }
    appOpenMsLiveStream(): void {
        console.log('appOpenMsLiveStream');
    }
    appOnLeavePreferencePage(): void {
        console.log('appOnLeavePreferencePage-----------IOS');
    }
    addCalendarEvent(
        title: string,
        description: string,
        eventUUID: string,
        startTime: number,
        endTime: number
    ): void | any {
        console.log('appOpenMsLiveStream-----IOS');
    }
    setAllBettingStrategies(value: boolean): void {
        console.log('setAllBettingStrategies-----IOS');
    }
}
